import { Accordion } from '@/components/Accordion';
import { CartOrdersList } from '@/components/CartOrdersList';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import type { OrderItem } from '@/types';

interface OrderSummaryProps {
  orders: OrderItem[] | null;
  subtotal?: string;
}

export const OrderSummary = ({ orders, subtotal }: OrderSummaryProps) => {
  const isWideScreen = useMediaQuery('(width >= 48rem)');

  return orders ? (
    <Accordion
      headingLevel={2}
      isDefaultExpanded={isWideScreen}
      isFullWidth={!isWideScreen}
      previewText={subtotal}
      triggerText="Order summary"
    >
      <CartOrdersList orders={orders} />
    </Accordion>
  ) : null;
};
